// Upload Wizard Context
import { createContext, useContext, ReactNode } from 'react';
import { UploadWizardContextType } from '../types';

const UploadWizardContext = createContext<UploadWizardContextType | undefined>(undefined);

export const useUploadWizardContext = () => {
  const context = useContext(UploadWizardContext);
  if (!context) {
    throw new Error('useUploadWizardContext must be used within UploadWizardProvider');
  }
  return context;
};

interface UploadWizardProviderProps {
  children: ReactNode;
  value: UploadWizardContextType;
}

export const UploadWizardProvider: React.FC<UploadWizardProviderProps> = ({ children, value }) => {
  return (
    <UploadWizardContext.Provider value={value}>
      {children}
    </UploadWizardContext.Provider>
  );
};

